import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function generateTitleFallback(fields: SchemaField[]): string {
  const fieldNames = new Set(fields.map((f) => f.name))
  const fallbacks: string[] = []
  if (fieldNames.has('title')) fallbacks.push('row.original.title')
  if (fieldNames.has('name')) fallbacks.push('row.original.name')
  fallbacks.push('row.original.id')
  fallbacks.push("''")
  return fallbacks.join(' || ')
}
